import { useQuery } from '@tanstack/react-query';

import { User } from '../../../../../types';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { unwrapPaginatedResponseDataAs } from '../../../../logic/unwrapPaginatedResponseDataAs';
import { PaginatedResponse } from '../../../../types/PaginatedResponse';
import { USER_BASE_PATH } from '../../constants/userBasePath';
import { getUserAssignees } from '../../requests/getUserAssignees';

export const useUserAssignees = (
  searchParams?: Record<string, any>,
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    PaginatedResponse<User[]> | undefined
  >({
    queryKey: [USER_BASE_PATH, 'assignees', searchParams],
    queryFn: () => getUserAssignees(constructGet, searchParams),
    ...options,
  });

  return {
    ...unwrapPaginatedResponseDataAs(data, refetch, 'userAssignees'),
    ...rest,
  };
};
